import script from "./SubscriptionItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubscriptionItem.vue?vue&type=script&setup=true&lang=ts"

import "./SubscriptionItem.vue?vue&type=style&index=0&id=04af4936&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04af4936"]])

export default __exports__